function imageCycle() {
  var nextButton = $('.image-carousel .slick-next.slick-arrow');
  var slidesContainer = $('.image-carousel .section_slides-container');
  var slideShowInterval;
  var slideShowSpeed = 3500; // Adjust the speed as needed (milliseconds)
  var isInteracting = false; // Flag to track user interaction

  function cycleSlides() {
    var currentSlideIndex = slidesContainer.slick('slickCurrentSlide');
    var totalSlides = slidesContainer.find('.slick-slide').length;

    if (currentSlideIndex === totalSlides - 1) {
      // If on the last slide, go to the first slide
      slidesContainer.slick('slickGoTo', 0);
      // Reset interaction flag and restart the slideshow
      isInteracting = false;
      startSlideShow();
    } else {
      // Otherwise, go to the next slide
      nextButton.click();
    }
  }

  function startSlideShow() {
    if (!isInteracting) {
      clearInterval(slideShowInterval); // Clear any existing interval
      slideShowInterval = setInterval(cycleSlides, slideShowSpeed);
    }
  }

  function stopSlideShow() {
    clearInterval(slideShowInterval);
    isInteracting = true;
  }

  slidesContainer.on('mousedown touchstart', stopSlideShow);

  $(window).on('mouseup touchend', function () {
    isInteracting = false;
    startSlideShow();
  });

  startSlideShow(); // Start the slideshow initially
}

// Function to dispatch the resize event
function dispatchResizeEvent() {
  // Create the event
  var event;
  if (typeof Event === 'function') {
    // Modern browsers
    event = new Event('resize');
  } else {
    // For IE and older browser versions
    event = document.createEvent('Event');
    event.initEvent('resize', true, true);
  }
  // Dispatch/trigger the event
  window.dispatchEvent(event);
}
// Delay the dispatch of the resize event using setTimeout

$(document).ready(function () {
  setTimeout(dispatchResizeEvent, 30); // Adjust the delay time (in milliseconds) as needed
  //setTimeout(imageCycle, 100); // Adjust the delay time (in milliseconds) as needed
});
